/**
 * @deprecated OPS-STAB-001 role buckets — use resolveOperationalAccess (OPS-STAB-002).
 */
import { resolveOperationalAccess } from './resolveOperationalAccess.js';

export function createOperationalAccessFromUser(user, options = {}) {
  if (!user) return resolveOperationalAccess(options);
  return resolveOperationalAccess({
    permissions: user.permissionList ?? user.permissions ?? [],
    uriList: user.uriList ?? [],
    menuItems: user.menuItemList ?? user.menuItems ?? [],
    accessControlList: user.accessControlList ?? [],
    operationalModules: user.operationalModules ?? user.operationalModuleAccess ?? null,
    shell: options.shell ?? user.shell,
  });
}

export function hasCapability(accessOrRoles, moduleId) {
  if (accessOrRoles?.canAccessModule) {
    return accessOrRoles.canAccessModule(moduleId);
  }
  return false;
}

export function filterNavByCapabilities(navItems, accessOrUser, options = {}) {
  const access =
    accessOrUser?.canAccessModule != null
      ? accessOrUser
      : createOperationalAccessFromUser(accessOrUser, options);
  return navItems.filter((item) => !item.moduleId || access.canAccessModule(item.moduleId));
}
